import { noop } from 'lodash';

const useConsoleLog = process.env.NODE_ENV === 'development';

function consoleLog(...args) {
	if (args.length > 1) {
		console.log(...args);
	} else {
		console.log(args[0]);
	}
}

const log = useConsoleLog ? consoleLog : noop;

export default log;



// WEBPACK FOOTER //
// ./src/utils/log.js